export default "__VITE_ASSET__f258e34d__"